import React from 'react';
import { DefaultBsComponent, PayFitColor } from '../../types/module';
import { classNames } from '../../utils/style';
import { applyBgColor } from '../../utils/utils';

export interface PricingHighlightProps extends DefaultBsComponent {
  /** The content to be highlighted */
  children: React.ReactNode;
  /** Optional background color from PayFit color palette */
  color?: PayFitColor;
}

/**
 * Highlight component used in pricing cards to emphasize important information
 * with a colored background.
 *
 * @example
 * ```tsx
 * <Highlight color="yellow">Special offer</Highlight>
 * ```
 */
export const Highlight = ({
  children,
  className,
  color = 'yellow',
}: PricingHighlightProps) => {
  return (
    <div
      className={classNames(
        'rounded-[4px] text-14 leading-[16.8px] py-4 px-8',
        applyBgColor(color),
        className,
      )}
      role="mark"
    >
      {children}
    </div>
  );
};
